module.exports = ($scope, Api, subjects, heimdallClassifications) ->
  $scope.filters = { classification: null }

  $scope.loadPage = (page) ->
    $scope.offset = ((page or 1) - 1) * 10
    if $scope.filters.subjectType == "individual"
      first_name = $scope.filters.firstName
      last_name = $scope.filters.lastName
    else
      # All + Company
      first_name = $scope.filters.fullName
      last_name = ""

    params =
      offset: $scope.offset
      limit: 10
      first_name: first_name
      last_name: last_name
      classification: $scope.filters.classification
      type: $scope.filters.subjectType
    if $scope.filters.showOutstandingAlerts then params['outstanding_only'] = true
    $scope.loadData params

  $scope.loadData = (params) ->
    req = new Api.MonitoringSubjects.get(params).$promise
    $scope.loading = true
    req.then (subjects) ->
      $scope.subjects = subjects
      $scope.loading = false

  $scope.subjects = subjects
  $scope.filters.showOutstandingAlerts = true
  $scope.filters.subjectType = ''

  $scope.classifications = heimdallClassifications
  $scope.classificationFilters = Object.keys(heimdallClassifications.all())
